const LegalMentions = () => null;

export default LegalMentions;
